/* PFC Article — reading progress bar + TOC build + scrollspy */
(function () {
  const root = document.querySelector('[data-pfc-article]');
  if (!root) return;

  const content = root.querySelector('[data-pfc-article-content]');
  const progress = root.querySelector('[data-pfc-progress]');
  const tocList = root.querySelector('[data-pfc-toc-list]');
  const tocWrap = root.querySelector('[data-pfc-toc]');

  // Reading progress
  if (progress && content) {
    const onScroll = () => {
      const rect = content.getBoundingClientRect();
      const total = content.offsetHeight - window.innerHeight;
      const scrolled = -rect.top;
      const pct = Math.max(0, Math.min(100, (scrolled / Math.max(total, 1)) * 100));
      progress.style.width = pct + '%';
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // TOC build
  if (tocList && content) {
    const headings = content.querySelectorAll('h2, h3');
    if (headings.length < 2) {
      if (tocWrap) tocWrap.style.display = 'none';
      return;
    }

    const slug = (s) =>
      s
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-')
        .slice(0, 60);

    const used = new Set();
    const items = [];
    headings.forEach((h) => {
      let id = h.id || slug(h.textContent || '');
      let unique = id;
      let i = 2;
      while (used.has(unique)) {
        unique = id + '-' + i++;
      }
      used.add(unique);
      h.id = unique;
      items.push({ id: unique, text: h.textContent, level: h.tagName.toLowerCase() });
    });

    tocList.innerHTML = items
      .map(
        (it) =>
          `<li class="is-${it.level}"><a href="#${it.id}">${it.text.replace(/</g, '&lt;')}</a></li>`
      )
      .join('');

    // Scrollspy
    const links = tocList.querySelectorAll('a');
    const linkById = new Map();
    links.forEach((a) => linkById.set(a.getAttribute('href').slice(1), a));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            links.forEach((l) => l.classList.remove('is-active'));
            const link = linkById.get(e.target.id);
            if (link) link.classList.add('is-active');
          }
        });
      },
      { rootMargin: '-80px 0px -70% 0px' }
    );
    headings.forEach((h) => observer.observe(h));
  }
})();
